var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-wrapper",class:{
  'has-header': !!_vm.$slots.header
}},[(!!_vm.$slots.header)?_c('div',{staticClass:"data-wrapper-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-wrapper-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fe83664","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data/DataWrapper.vue
// module id = null
// module chunks = 